// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider-module--divider--73f316","content":"Divider-module--content--d15b40","footnote":"Divider-module--footnote--2850c5"};